module.exports = __webpack_public_path__ + "img/frase_balao-1-5.2cd02a57.svg";